/* global axios */
import ApiClient from './ApiClient';

class VivoCopilotAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  show(conversationId) {
    return axios.get(`${this.url}/${conversationId}/vivo_copilot`);
  }

  create(conversationId, data) {
    return axios.post(`${this.url}/${conversationId}/vivo_copilot`, data);
  }
}

export default new VivoCopilotAPI();
